module.exports = __webpack_public_path__ + "static/media/Skin_tone_6.67681e4f.svg";